export default __webpack_public_path__ + "7fa233dbdbe2fa3a1162734aa3404e70.png";